import { PvsCreative } from 'models/interfaces';

function validateCreativePlatform(value: string) {
  if (!value) {
    return 'Platform is required.';
  }

  return null;
}

function validateCreativeName(value: string) {
  if (!value) {
    return 'File name is required.';
  }

  const fileExtensionRegex = new RegExp(/[0-9a-z]+$/);
  const fileExtension = fileExtensionRegex.exec(value);

  if (!fileExtension || !fileExtension[0]) {
    return 'File name must end with file extension.';
  }

  return null;
}

function creativeIsPublishable(value: PvsCreative) {
  if (!value.bucket_key) {
    return false;
  }

  if (!value.click_url) {
    return false;
  }

  if (!value.name) {
    return false;
  }

  if (!value.platform_id) {
    return false;
  }

  if (!value.is_active) {
    return false;
  }

  return true;
}

export { validateCreativeName, validateCreativePlatform, creativeIsPublishable };
